module.exports = __webpack_public_path__ + "img/figure03_sp.0a8772d9.png";